var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-nowrap justify-content-between"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"pull-right ml-1"},[_c('div',{staticClass:"d-flex"},[_vm._t("default"),_vm._v(" "),(_vm.helpDocId)?_c('c-button-help',{attrs:{"link":_vm.helpDocId}}):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }